import ReachAlert, {AlertProps} from '@reach/alert'
import {ReactNode} from 'react'

export const Alert = ({
  type,
  children
}: {
  type: AlertProps['type']
  children: ReactNode
}) => {
  return <ReachAlert type={type}>{children}</ReachAlert>
}
